/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Grid} from '@scuf/common';
import {FAULT_STATES, CURRENT_FAULT_STATES} from "../common/FaultsConst";
import SearchInput from '../../common/SearchInput'
import CheckboxDropdown from '../../common/CheckboxDropdown'
import SortInput from "../../common/SortInput";

class FaultsFilterOld extends React.Component {

    getStateFilterOptions() {
        const {intl} = this.props
        return CURRENT_FAULT_STATES.map(state => {
            return {
                key: FAULT_STATES[state],
                text: intl.formatMessage({id: 'fault.detail.state.' + FAULT_STATES[state]}),
            }
        });
    }

    render() {
        const {intl} = this.props

        return (
            <div className={this.props.className}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={5} sWidth={12}>
                            <SearchInput placeholder={intl.formatMessage({id: "filter.search"})} fluid onChange={this.props.searchChanged}/>
                        </Grid.Column>
                        <Grid.Column width={3} sWidth={12}>
                            <SortInput value={this.props.sort} sortOptions={this.props.sortOptions} onChange={this.props.sortChanged}/>
                        </Grid.Column>
                        {this.props.stateChanged ?
                            <Grid.Column width={4} sWidth={12} className="states-filter">
                                <CheckboxDropdown label={intl.formatMessage({id: 'faults.filter.state'})} allOptions={this.getStateFilterOptions()} selectedOptions={this.props.states} onChange={this.props.stateChanged}/>
                            </Grid.Column>
                            :
                            ''
                        }
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

export default injectIntl(FaultsFilterOld)